import { defineStore } from "pinia"
import { ref, Ref } from "vue"

export const useSettingsStore = defineStore("settings", () => {
  const locale = 'fr'
  const siteId = 1
  const isMobile: Ref<boolean> = ref(false)
  const isPhablet: Ref<boolean> = ref(false)
  const isTablet: Ref<boolean> = ref(false)
  const isPhone: Ref<boolean> = ref(false)
  const isPortrait: Ref<boolean> = ref(false)
  const isLoading: Ref<boolean> = ref(false)
  const firstTimeApp: Ref<boolean> = ref(true)
  const profile: Ref<string> = ref('')
  const online: Ref<boolean> = ref(false)
  const isApp: Ref<boolean> = ref(false)
  const firstVisitProduct: Ref<boolean> = ref(true)
  const choicesAxeptio: Ref<any | null> = ref(null)

  const deviceDetection = ({ width, orientation }: { width: number, orientation: string }) => {
    isMobile.value = width <= 1024
    isTablet.value = width <= 1024 && width > 768
    isPhablet.value = width <= 768 && width > 565
    isPhone.value = width <= 565
    isPortrait.value = orientation === 'portrait'
  }

  const platformDetection = (platform: any) => {
    isApp.value = platform === 'android' || platform === 'ios'
  }

  return {
    locale,
    siteId,
    isMobile,
    isPhablet,
    isTablet,
    isPhone,
    isPortrait,
    isLoading,
    firstTimeApp,
    profile,
    online,
    isApp,
    firstVisitProduct,
    choicesAxeptio,
    deviceDetection,
    platformDetection
  }
}, {
  persist: true
})